import {
  THUMBNAIL_FRAME_NUMBER,
  THUMBNAIL_FRAME_NUMBER_LEGACY,
} from '../../../../constants';
import { DEFAULT_TILE_DIMENSIONS } from '../shared/constants';

const THUMBNAIL_FILENAME = {
  IMAGE: 'imageThumbnail.png',
  VIDEO: 'videoThumbnail.mp4',
};

export const ALT_THUMBNAIL_GENERATION_OPTIONS = {
  fileName: THUMBNAIL_FILENAME.IMAGE,
  frameNumber: THUMBNAIL_FRAME_NUMBER_LEGACY,
  height: DEFAULT_TILE_DIMENSIONS.HEIGHT,
  width: DEFAULT_TILE_DIMENSIONS.WIDTH,
};

export const THUMBNAIL_GENERATION_OPTIONS = {
  fileName: THUMBNAIL_FILENAME.IMAGE,
  frameNumber: THUMBNAIL_FRAME_NUMBER,
  height: DEFAULT_TILE_DIMENSIONS.HEIGHT,
  width: DEFAULT_TILE_DIMENSIONS.WIDTH,
};
